import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Projects from './views/Projects.vue';
import Skills from './views/Skills.vue';
import Awards from './views/Awards.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      toolbarName: 'Home',
      icon: 'home',
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
      toolbarName: 'Projects',
      icon: 'assignment',
    },
    {
      path: '/skills',
      name: 'skills',
      component: Skills,
      // toolbarName: 'Skills',
      icon: 'school',
    },
    {
      path: '/awards',
      name: 'awards',
      component: Awards,
      // toolbarName: 'Awards',
      icon: 'star',
    },
    {
      path: '', // required by vue-router, but left empty to use link instead
      link: 'https://gabriel.bearblog.dev/blog',
      name: 'blog',
      toolbarName: 'Blog',
      icon: 'book',
    },
  ],
});
